export default "__VITE_ASSET__BfIloyeP__"